import React, { Component } from 'react';
import PageHeader from '../../../app/layout/ui/header/PageHeader';
import SubHeader from '../../../app/layout/ui/header/SubHeader';
import WebUserForm from '../form';

class CreateWebUser extends Component {
	render() {
		return (
			<div>
				<PageHeader title="New Web User" />
				<SubHeader title="Create a new web user" />

				<div className="page-wrapper">
					<WebUserForm isNew />
				</div>
			</div>
		);
	}
}
export default CreateWebUser;
